export default __webpack_public_path__ + "static/l1-hero-img-ipad-d0c013f5a875668392fc51344cd5277b.png";